import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../CustomTable";
import CustomButton from "../CustomButton";
import moment from "moment";
import DatePicker from "../FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { useAuth } from "../../contexts/AuthContext";
import { storeColumns } from "../Columns/Vouchers/AllVouchers";
import { l1Columns } from "../Columns/Vouchers/ApprovedVouchers";
import { downloadReports, downloadReportsFun, getArrayOfSelectedStoresCode } from "../../utils/helpers";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { toast } from "react-toastify";

const ApprovedVouchers = () => {
  const { data = [], apiCall } = useApi();
  const {data: fileData,  apiCall: fileDownload } = useApi();
  const {data: fileStoreData,  apiCall: fileDownloadAtStore } = useApi();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation()
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );
  const {
    user: { userLabel = "" },
    selectedStores,
    storeDropdownState,
    currentStoreSelect, 
    setCurrentStoreSelect,
    user,
  } = useAuth();

  const { name: storeName } =
    selectedStores?.storeDetails || selectedStores?.[0] || {name:""};

  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [tableData, setTableData] = useState();

  const loc = useLocation()

  let pathVar = loc?.pathname?.split("/") || ""
  let subVoucherPath = pathVar[pathVar.length - 1]

  // let currentSubVoucherData = data?.storeWiseRecordsResponses?.find(i => i.storeName == currentStoreSelect)?.documents
  // useEffect(() => {
  //   if(subVoucherPath == "sub-voucher") {
  //     setTableData(currentSubVoucherData || [])
  //   }
  // }, [data])

  // useEffect(() => {
  //   if(subVoucherPath == "vouchers"){
  //     setTableData(data?.storeWiseRecordsResponses)
  //   } else {
  //     setTableData(currentSubVoucherData)
  //   }
  // }, [subVoucherPath])

  const mapSubVoucherData = () =>{
    let currentSubVoucherData = [];
      if(currentStoreSelect){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === currentStoreSelect
        )?.documents;
      }else if(storeName && storeName !== 'All'){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === storeName
        )?.documents;
      }else{
        currentSubVoucherData = data?.storeWiseRecordsResponses?.length > 0 ? data?.storeWiseRecordsResponses[0]?.documents : []
      }
      return currentSubVoucherData;
  }

  useEffect(() => {
    if (subVoucherPath === "sub-voucher") {
      setTableData(mapSubVoucherData() || []);
    }
  }, [data]);

  useEffect(() => {
    if (subVoucherPath === "vouchers") {
      setTableData(data?.storeWiseRecordsResponses);
    } else {
      setTableData(mapSubVoucherData());
    }
  }, [subVoucherPath]);

  const voucherApiCall = (start, end) => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: start,
          endDate: end,
        }).toString(),
      },
      { replace: true }
    );
    apiCall({
      url: apiUrls.dmsService.getRecords,
      dataToSend: {
        startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
        metadataSchemaId: 4,
        endDate: moment(end || start)
          .endOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
        searchText: "",
        status: "APPROVED",
        storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
        // storeCodes: selectedStores?.storeDetails?.storeCode
        //   ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
        //   : userLabel == "Store" ? null : [storeCode],
      },
      method: "post",
      processData: userLabel === "Store",
      accessor: "storeGetResponse",
      itemAccessor: "dataModalRecordsResponse",
    });
  };

  const isStoreActive = userLabel == "Store";
  useEffect(() => {
    // if (isStoreActive) {
      voucherApiCall(startDate, endDate);
    // } else {
    //   if (storeCode.length > 0 && storeCode.length !== 0) {
    //     voucherApiCall(startDate, endDate);
    //   }
    // }
  }, [selectedStores]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end) voucherApiCall(start, end);
  };

  const onClickChangeData = (data) => {
    setTableData(data);
  };

  const nonStoreColumns = useMemo(
    () =>
      l1Columns({
        tableData,
        extraColumns:  (subVoucherPath == "sub-voucher")
          ? [
              {
                Header: "V.ID",
                accessor: "id",
                Cell: (props) => {
                  const id = props?.row?.original?.id;
                  const isLink = id != null && id !== "";
                  return (
                    <div
                      className={
                        isLink ? "underline underline-offset-4 cursor-pointer" : ""
                      }
                      style={{ color: isLink ? "blue" : "" }}
                      onClick={() => {
                        if (isLink) {
                          const row = props?.row?.original;
                          navigate(`/vouchers/${id}`, {
                            state: {
                              ...row,
                              type: "Approved",
                              approvedDocs: row ? [row] : [],
                              approvedAmount: row?.approvedAmount ?? row?.amount,
                            },
                          });
                        }
                      }}
                    >
                      {id}
                    </div>
                  );
                },
              },
            ]
          : [
              {
                Header: "Store Name",
                accessor: "storeName",
                Cell: (props) => {
                  const store_name = props?.row?.original?.storeName;
                  return (
                    <div
                      className="cursor-pointer underline underline-offset-4"
                      style={{ color: "blue" }}
                      onClick={() => {
                        navigate(
                          {
                            pathname: "sub-voucher",
                            search: createSearchParams({
                              startDate: startDate,
                              endDate: endDate,
                            }).toString(),
                          }
                        );
                        setCurrentStoreSelect(store_name)
                        return onClickChangeData(
                          props?.row?.original?.documents
                        );
                      }}
                    >
                      {store_name}
                    </div>
                  );
                },
              },
            ],
      }),
    [tableData, startDate, endDate]
  );
  const memoStoreColumns = useMemo(() => storeColumns({ navigate }), []);

  const onClickDownloadFile = () => {
    // const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    // const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownload({
      url: `${apiUrls.dmsService.getDownloadVoucherReport}`,
      // dataToSend: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
      dataToSend: {
        voucherIds: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
        status: "Approved",
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if(status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "ApprovedVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  const getStoreCodeByName = (storeName) => {
    return storeDropdownState.find(i => i.name == storeName)?.storeCode
  }

  const downloadVoucherAtStoreLevel = () => {
    const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownloadAtStore({
      url: `${apiUrls.dmsService.downloadVoucherStoreLevel}`,
      dataToSend: {
        storeCodes: selectedCheckBoxes?.map((i) =>
          getStoreCodeByName(i.original.storeName)
        ),
        status: "Approved",
        metadataSchemaId: 4,
        endDate: et,
        startDate: st,
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "ApprovedVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  }
  return (
    <div className="flex flex-col py-2">
      <div className="flex justify-end mt-2 mb-8">
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>

          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            maxDate={new Date()}
            dateRange
          />
        </div>
      </div>
      <CustomTable
        data={
          tableData
            ? tableData
            : userLabel === "Store"
            ? data
            : data?.storeWiseRecordsResponses || []
        }
        columns={userLabel === "Store" ? memoStoreColumns : nonStoreColumns}
        showCheckboxes={true}
        onCheckboxSelect={(selectedCheckBoxes) => {
          const data1 =
            userLabel === "Store"
              ? data
              : data?.storeWiseRecordsResponses || [];
          if (data1?.length) {
            setSelectedCheckBoxes(selectedCheckBoxes);
          }
        }}
        centerAlignedColumns={[
          "l1_status",
          "l2_status",
          "amount",
          "ac_status",
          "approved_amount",
        ]}
        // isGlobalSearchEnable
        // globalSearchPosition={{
        //   top: "-63px",
        //   left: 0,
        // }}
      />
      <CustomButton
        title="Download"
        wrapperClassName={`self-end !px-10 mt-5 ${
          selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
        }`}
        // onClick={() => {
        //   let reportSettings = {
        //     fileName: "Approved Vouchers", // Name of the resulting spreadsheet
        //     extraLength: 3, // A bigger number means that columns will be wider
        //     writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        //     writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        //     RTL: false, // Display the columns from right-to-left (the default value is false)
        //   };
        //   if (data?.storeWiseRecordsResponses) {
        //     downloadReports(
        //       [
        //         {
        //           sheet: "Approved Vouchers",
        //           columns: [
        //             {
        //               label: "Store Name",
        //               value: (row) => selectedStores?.storeDetails?.name || "All",
        //             }, // Top level data
        //             { label: "Submitted On", value: (row) => row.submittedOn }, // Top level data
        //             { label: "Amount", value: (row) => row.amount }, // Top level data
        //             { label: "Approved", value: (row) => row.approvedAmount }, // Top level data
        //           ],
        //           content: selectedCheckBoxes?.map((item) => {
        //             return item?.original
        //           }),
        //         },
        //       ],
        //       reportSettings
        //     );
        //   }

        //   if (data?.length > 0) {
        //     downloadReports(
        //       [
        //         {
        //           sheet: "All Vouchers",
        //           columns: [
        //             {
        //               label: "VID",
        //               value: (row) => row.vid,
        //             }, // Top level data
        //             { label: "Submitted On", value: (row) => row.submittedOn }, // Top level data
        //             { label: "Amount", value: (row) => row.amount }, // Top level data
        //             {
        //               label: "L1 Status",
        //               value: (row) => row.L1?.status || "-",
        //             }, // Top level data
        //             {
        //               label: "L2 Status",
        //               value: (row) => row.L2?.status || "-",
        //             }, // Top level data
        //             {
        //               label: "A/C Status",
        //               value: (row) => row.L3?.status || "-",
        //             }, // Top level data
        //             {
        //               label: "Approved Amount",
        //               value: (row) => row?.L3?.approvedAmount || "-",
        //             }, // Top level data
        //           ],
        //           content: selectedCheckBoxes?.map((item) => item?.original),
        //         },
        //       ],
        //       reportSettings
        //     );
        //   }
        // }}
        onClick={() => {
          if(selectedCheckBoxes?.map((item) => item?.original)[0]?.storeName){
            
            downloadVoucherAtStoreLevel()
          } else {
            onClickDownloadFile()
          }
        }}
      />
    </div>
  );
};

export default ApprovedVouchers;
